import { createSlice } from "@reduxjs/toolkit";

export interface CaseToOperateState {
  isLoadingCtos: boolean;
  isLoadingCto: boolean;
  isLoadingCtoHistoryLog: boolean;
  isLoadingRelatedCtos: boolean;
  sces: string[];
  isLoadingSces: boolean;
  mahs: string[];
  isLoadingMahs: boolean;
  isLoadingContingencyPlans: boolean;
  isLoadingPerformanceStandards: boolean;
  submitFormSuccess: boolean;
  isSubmittingForm: boolean;
  isUploadingFiles: boolean;
  isDeletingFiles: boolean;
  loadingFileId: number;
  degradedSces: string[];
  isLoadingDegradedSces: boolean;
  tagsBySce: string[];
  isLoadingTagsBySce: boolean;
  isLoadingCheckCtosBySce: boolean;
}

export const caseToOperateSlice = createSlice({
  name: "caseToOperate",

  initialState: {
    isLoadingCtos: false,
    cto: undefined,
    isLoadingCto: false,
    ctoHistoryLog: [],
    isLoadingCtoHistoryLog: false,
    relatedCtos: [],
    isLoadingRelatedCtos: false,
    sces: [],
    isLoadingSces: false,
    mahs: [],
    isLoadingMahs: false,
    contingencyPlans: [],
    isLoadingContingencyPlans: false,
    performanceStandards: [],
    isLoadingPerformanceStandards: false,
    submitFormSuccess: false,
    isSubmittingForm: false,
    isUploadingFiles: false,
    isDeletingFiles: false,
    loadingFileId: -1,
    degradedSces: [],
    isLoadingDegradedSces: false,
    tagsBySce: [],
    isLoadingTagsBySce: false,
    checkCtosBySce: undefined,
    isLoadingCheckCtosBySce: false,
  } as CaseToOperateState,

  reducers: {
    setIsLoadingCtos: (state, action) => {
      state.isLoadingCtos = action.payload;
    },

    setIsLoadingCto: (state, action) => {
      state.isLoadingCto = action.payload;
    },
    setIsLoadingCtoHistoryLog: (state, action) => {
      state.isLoadingCtoHistoryLog = action.payload;
    },

    setIsLoadingRelatedCtos: (state, action) => {
      state.isLoadingRelatedCtos = action.payload;
    },
    setSces: (state, action) => {
      state.sces = action.payload;
    },
    setIsLoadingSces: (state, action) => {
      state.isLoadingSces = action.payload;
    },
    setMahs: (state, action) => {
      state.mahs = action.payload;
    },
    setIsLoadingMahs: (state, action) => {
      state.isLoadingMahs = action.payload;
    },

    setIsLoadingContingencyPlans: (state, action) => {
      state.isLoadingContingencyPlans = action.payload;
    },

    setIsLoadingPerformanceStandards: (state, action) => {
      state.isLoadingPerformanceStandards = action.payload;
    },
    setSubmitFormSuccess: (state, action) => {
      state.submitFormSuccess = action.payload;
    },
    setIsSubmittingForm: (state, action) => {
      state.isSubmittingForm = action.payload;
    },
    setIsUploadingFiles: (state, action) => {
      state.isUploadingFiles = action.payload;
    },
    setIsDeletingFiles: (state, action) => {
      state.isDeletingFiles = action.payload;
    },
    setLoadingFileId: (state, action) => {
      state.loadingFileId = action.payload;
    },
    setDegradedSces: (state, action) => {
      state.degradedSces = action.payload;
    },
    setIsLoadingDegradedSces: (state, action) => {
      state.isLoadingDegradedSces = action.payload;
    },
    setTagsBySce: (state, action) => {
      state.tagsBySce = action.payload;
    },
    setIsLoadingTagsBySce: (state, action) => {
      state.isLoadingTagsBySce = action.payload;
    },

    setIsLoadingCheckCtosBySce: (state, action) => {
      state.isLoadingCheckCtosBySce = action.payload;
    },
  },
});

export const actions = {
  ...caseToOperateSlice.actions,
};
